import { useContext, useEffect, useState } from "react";
import Skill from "./Skill";
import { Resume } from "./Resume";
import { Layout } from "./Layout";
import { DataProvider } from "../../../store/ContextProvider";
import { useLocation, useNavigate } from "react-router-dom";

export const ProfessionalProfile = ({ candidate, fetchCandidateData }) => {
  const { currentUser } = useContext(DataProvider)
  const [, setSkillsList] = useState([]);
  const [, setResume] = useState()
  const [skills, setSkills] = useState([]);
  const navigate = useNavigate()

  // fetch the query:;

  const location = useLocation()
  const queryFetch = new URLSearchParams(location.search)
  const reverse = queryFetch.get('inverse') === "true"
  const previous = location.state?.from || '/account'
  const active = location.state?.active || 'Overview'


  const handleResumeData = (resume) => {
    setResume(resume)
  }
  const handleAddSkillData = (skills) => {
    setSkillsList(skills);
  }

  useEffect(() => {
    fetchCandidateData()
  }, [])

  useEffect(() => {
    if (candidate) {
      setSkills(candidate.skills)
    }
  }, [candidate])

  const handleNext = () => {
    if (!skills || skills.length === 0) {
      alert("Please add at least one skill before continuing");
      return;
    }
    if (reverse)
      navigate(previous, { state: { active } })
    else
      navigate(`/update-account/personalInformation?userId=${currentUser?._id}`);
  };

  return (
    <Layout candidate={candidate}>
      <section className="mb-24">
        <div className="w-full">
          <Resume submitData={handleResumeData}  _id={candidate._id} applicantID={candidate.applicantID} resumeAvailable={candidate.resumeAvailable} resumeLink={candidate.resumeLink} applicantName={candidate.applicantName} experience={candidate.experience} />
        </div>
        {/* Skill Input */}
        <div className="w-full">
          <Skill submitData={handleAddSkillData} candidate={candidate} />
        </div>
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-end items-center gap-4 w-full">
          <button
            type="button"
            onClick={handleNext} // show collected skills
            className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
          >
            {reverse ? 'Update' : 'Next'}
          </button>
        </div>
      </section>
    </Layout>
  );
};
